import { hasPagePermissions } from 'hooks/hasPagePermissions'
import { EmailDNSSetup } from 'pages/Admin/AdminTools/EmailDNSSetup'
import { EmailLogs } from 'pages/Admin/AdminTools/EmailLogs'
import { useEffect, useState } from 'react'
import { ButtonGroup } from 'stories/components'

import { EmailRestrictions } from '../EmailRestrictions'
import { DefaultSenderEmailSettings } from '../EmailTexts/DefaultSenderEmailSettings'
import { EmailModalDefaultsConfig } from '../EmailTexts/EmailModalDefaultsConfig'
import { EmailPartiesConfig } from '../EmailTexts/EmailPartiesConfig'
import { EmailsHardcoded } from '../EmailTexts/EmailsHardcoded'
import { PipelineServicingEmailHeadersConfig } from '../EmailTexts/PipelineServicingEmailHeadersConfig'
import { WeeklyLoanReportConfig } from '../EmailTexts/WeeklyLoanReportConfig'
import { EmailSetupSettings } from './EmailSetupSettings'

const tabs = {
  setup: 'Setup',
  restrictions: 'Email Restrictions',
  weeklyReport: 'Weekly Loan Report',
  parties: 'Parties Configuration',
  hardcoded: 'Hardcoded Emails',
  emailModalDefaults: 'Default email recipients',
  pipelineServicingEmailHeaders: 'Pipeline Servicing Email Headers',
  defaultSettings: 'Default Settings',
  dns: 'Email DNS Setup',
  logs: 'Email Logs',
}

export const EmailSetup = ({ initialTab }: { initialTab?: string }) => {
  const dnsAllowed = hasPagePermissions(['admin_tool', 'emailDNSSetup'])
  const logsAllowed = hasPagePermissions(['admin_tool', 'emailLogs'])
  const requested = initialTab === 'dns' && dnsAllowed ? 'dns' : initialTab === 'logs' && logsAllowed ? 'logs' : 'setup'
  const [tab, setTab] = useState(requested)

  useEffect(() => {
    if (initialTab === 'dns' && dnsAllowed) setTab('dns')
    if (initialTab === 'logs' && logsAllowed) setTab('logs')
  }, [initialTab])

  const renderContent = () => {
    switch (tab) {
      case 'restrictions':
        return <EmailRestrictions />
      case 'weeklyReport':
        return <WeeklyLoanReportConfig />
      case 'parties':
        return <EmailPartiesConfig />
      case 'hardcoded':
        return <EmailsHardcoded />
      case 'emailModalDefaults':
        return <EmailModalDefaultsConfig />
      case 'pipelineServicingEmailHeaders':
        return <PipelineServicingEmailHeadersConfig />
      case 'defaultSettings':
        return <DefaultSenderEmailSettings />
      case 'dns':
        return <EmailDNSSetup />
      case 'logs':
        return <EmailLogs />
      default:
        return <EmailSetupSettings />
    }
  }

  const visibleTabs = Object.fromEntries(
    Object.entries(tabs).filter(([key]) => (key !== 'dns' || dnsAllowed) && (key !== 'logs' || logsAllowed)),
  )

  return (
    <div>
      <ButtonGroup title={visibleTabs} value={tab} onChange={setTab} />
      <div className="mt-4">{renderContent()}</div>
    </div>
  )
}
